// extracted by mini-css-extract-plugin
module.exports = {"StrollerDetailRating":"xe_a bha_a bha_x","StrollerDetailRating__muted":"xe_b bha_fi"};